export const mobile = {
  title: "Control your store where you are with your mobile",
  benefit1: "Manage your inventory and upload images of your products without any complications",
  benefit2: "Accept payments, track your orders and customers",
  benefit3: "Offer discounts and special offers to increase sales",
  qr: "Scan QR",
  qrAndroidLabel: "Google Play",
  qrIosLabel: "App Store",
};
